var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"club",on:{"click":_vm.goClub}},[_vm._v(_vm._s(_vm.club))])
}
var staticRenderFns = []

export { render, staticRenderFns }